import { EntityIcon } from '..';
import { TProps } from '../types/TProps';

const tableMuted30SizeClassName =
  'h-[30px] w-[30px] bg-[var(--color-surface-muted)] text-base leading-[30px] text-[var(--color-text)]';

export const EntityIconTableMuted30 = ({ className, sizeClassName, ...props }: TProps) => (
  <EntityIcon {...props} sizeClassName={sizeClassName ?? tableMuted30SizeClassName} className={className} />
);
